import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import ListaRevendedoresView from '@/views/revendedor/ListaRevendedoresView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: '/revendedores',
      name: 'revendedores',
      component: ListaRevendedoresView,
      meta: {
        requiresAuth: true,
        title: 'Lista de Revendedores',
        nome_fisico: 'editar-revendedor' 
      }
    },
    {
      path: '/revendedores/:id',
      name: 'revendedor-detalhes',
      component: () => import('@/views/revendedor/RevendedorDetalhesView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Detalhes do Revendedor',
        nome_fisico: 'editar-revendedor' 
      }
    },
    
  ],
}
